<template>
  <ChatModal
    name="callout-profile"
    :title="$t('callout.profileTitle')"
    @before-open="beforeOpen"
  >
    <div v-if="profile" slot="default">
      <div :class="$style.header">
        <!-- <div :class="$style.avatar">
          <img :src="profile.logo" :alt="`${profile.name} icon`">
        </div> -->
        <CalloutAvatar
          :source="profile.logo"
          :class="$style.avatar"
          :size="51"
        />
        <div :class="$style.info">
          <div :class="$style.name">{{ profile.name }}</div>
        </div>
      </div>
      <div :class="$style.section">
        <div :class="$style.sectionItem">
          <div :class="$style.sectionItemLabel">{{ $t('callout.profileDescriptionLabel') }}</div>
          <div :class="$style.sectionItemText">{{ profile.description }}</div>
        </div>
        <div :class="$style.bottomBlock">
          <span
            :class="[$style.subscribeButton, { [$style.unsubscribe]: profile.isSubscribed }]"
            @click="toggleSubscription"
          >
            {{ profile.isSubscribed ? $t('callout.unsubscribe') : $t('callout.subscribe') }}
          </span>
        </div>
      </div>
    </div>
  </ChatModal>
</template>

<script>
import ChatModal from './ChatModal'
import { mapGetters, mapActions } from 'vuex'
import CalloutAvatar from '@/views/Messenger/callouts/CalloutAvatar'

export default {
  name: 'profile-popup',
  components: {
    ChatModal,
    CalloutAvatar
  },
  data () {
    return {
      uuid: null
    }
  },
  computed: {
    ...mapGetters({
      getCalloutProfile: 'entities/calloutProfiles/find'
    }),
    profile () {
      return this.getCalloutProfile(this.uuid)
    }
  },
  methods: {
    beforeOpen ({ params: { uuid } }) {
      this.uuid = uuid
      if (!this.profile) {
        this.fetchProfiles([uuid])
      }
    },
    ...mapActions({
      fetchProfiles: 'entities/calloutProfiles/fetch',
      changeSubscriptionStatus: 'entities/calloutProfiles/changeSubscriptionStatus'
    }),
    toggleSubscription () {
      if (this.profile.isSubscribed) {
        this.unsubscribe()
        return
      }
      this.subscribe()
    },
    subscribe () {
      this.changeSubscriptionStatus(this.uuid)
    },
    unsubscribe () {
      this.$modal.show('confirm', {
        content: this.$t('callout.unsubscribeConfirmation', { name: this.profile.name }),
        onSubmit: () => {
          this.changeSubscriptionStatus(this.uuid)
        }
      })
    }
  }
}
</script>

<style lang="scss" module>
.header {
  background-color: $main-bg-colored;
  height: 90px;
  display: flex;
  align-items: center;
  padding: 0 20px;
}
.avatar {
  // width: 51px;
  // height: 51px;
  // border-radius: 50%;
  margin-right: 12px;
  // :global(img) {
  //   width: 100%;
  //   height: 100%;
  //   object-fit: cover;
  // }
}
.info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: $text-lightest;
}
.name {
  font-size: 16px;
  font-weight: 500;
}

.section {
  padding: 12px 10px 20px 82px;
}
.sectionItem {
  margin-bottom: 18px;
  &Label {
    color: $text-mid;
    margin-bottom: 4px;
  }
  &Text {
    font-size: 16px;
  }
}

// .headerActions {
//   position: relative;
//   top: -20px;
//   display: flex;
//   justify-content: flex-end;
//   padding-right: 60px;
// }
// .headerActionBtn {
//   margin-left: 24px;
// }
.bottomBlock {
  margin-top: 40px;
}
.subscribeButton {
  color: $text-success;
  font-size: 14px;
  cursor: pointer;
  &.unsubscribe {
    color: $text-error;
  }
}
</style>
